import { DateTimeUtil } from '@shared/utils/DateTime'

export const DateTimeHelper = {
  ...DateTimeUtil
}
